import React, {Component} from 'react';

export default class Loading extends Component {
  render() {
    return(
      <div className="row">
        <div className="col-md-12 text-center mt-5">
          <h4>loading...</h4>
        </div>
      </div>
    );
  }
}
